;(function() {
/* @ngInject */
function BusinessSubjectSearchEngineFactory(removeDiacritics) {
  const Bm25K1 = 1.2;
  const Bm25B = 0.75;
  const RrfK = 60;
  const SlovakSuffixes = [
    "encami", "encoch", "eniec", "encom", "atami", "ätami", "atách",
    "ätách", "ence", "aťom", "äťom", "atám", "ätám", "iami", "iach",
    "očka", "ôčka", "íčko", "ovia", "ovi", "ými", "ati", "äti", "iam",
    "ých", "aťa", "äťa", "atá", "ätá", "aťu", "äťu", "ému", "iou",
    "och", "ach", "ách", "osť", "oba", "ota", "ček", "ého", "ami",
    "ie", "ím", "ým", "iu", "ov", "at", "ät", "ií", "ik", "ík", "ok",
    "ka", "ej", "om", "ou", "ám", "ia", "ii", "mi", "ú", "é", "ä", "ý",
    "e", "á", "y", "o", "í", "i", "a", "u"
  ];
  const SlovakSpecialEndings = [
    { ending: "er", replacement: "r" },
    { ending: "ok", replacement: "k" },
    { ending: "zeň", replacement: "ň" },
    { ending: "ol", replacement: "l" },
    { ending: "ic", replacement: "ik" },
    { ending: "um", replacement: "" }
  ];
  const IgnoredCategories = {
    ostatne: true,
    other: true,
    others: true
  };
  const GenericContentPrefixes = [
    "v ramci zivnostenskeho opravnenia je mozne vykonavat",
    "v ramci zivnostenskeho opravnenia mozno vykonavat",
    "within the scope of the trade licence namely the following activities may be performed",
    "within the scope of the trade authorisation it is possible to perform",
    "within the scope of the trade authorization it is possible to perform"
  ];

  let index = emptyIndex();

  return {
    buildIndex,
    search
  };

  function emptyIndex() {
    return {
      items: [],
      language: "sk",
      nameCorpus: createCorpus([]),
      contentCorpus: createCorpus([]),
      packageProfiles: {},
      category2Profile: null
    };
  }

  function buildIndex(subjects, categoryDefinitions, language) {
    let safeSubjects = Array.isArray(subjects) ? subjects : [];
    let safeCategoryDefinitions = categoryDefinitions || {};
    let normalizedLanguage = language === "en" ? "en" : "sk";
    let items = safeSubjects.map((subject, originalIndex) => buildItem(subject, originalIndex, normalizedLanguage));
    let nameDocuments = items.map(item => item.nameDocument);
    let contentDocuments = [];

    items.forEach(item => {
      item.contentParts.forEach(part => contentDocuments.push(part.document));
    });

    index = {
      items,
      language: normalizedLanguage,
      nameCorpus: createCorpus(nameDocuments),
      contentCorpus: createCorpus(contentDocuments),
      packageProfiles: buildPackageProfiles(items, safeCategoryDefinitions, normalizedLanguage),
      category2Profile: buildCategory2Profile(safeCategoryDefinitions, normalizedLanguage)
    };
  }

  function search(query, limit) {
    let preparedQuery = prepareText(query, index.language);
    if (!preparedQuery.phrase || index.items.length === 0) {
      return [];
    }

    let candidates = {};
    addExactNameMatches(candidates, preparedQuery);

    let nameRanking = rankNames(preparedQuery.tokens);
    let contentRanking = rankContent(preparedQuery.tokens);
    let contentPhraseRanking = rankContentPhrases(preparedQuery);
    let aliasRanking = rankAliases(preparedQuery);
    let packageRanking = rankPackageTags(preparedQuery);
    let category2Ranking = rankCategory2(preparedQuery);
    let categoryRanking = rankCategories(preparedQuery);

    addRanking(candidates, nameRanking, "name", "bm25-name");
    addRanking(candidates, contentRanking, "content", "bm25-content");
    addRanking(candidates, contentPhraseRanking, "contentPhrase", "content-phrase");
    addRanking(candidates, aliasRanking, "alias", "alias");
    addRanking(candidates, packageRanking.results, "packageTag", packageRanking.matchedBy);
    addRanking(candidates, category2Ranking, "category2", "category:eshop");
    addRanking(candidates, categoryRanking, "category", "category");

    let results = Object.keys(candidates)
      .map(key => candidates[key])
      .sort(compareCandidates);

    results.forEach((candidate, resultIndex) => {
      candidate.finalRank = resultIndex + 1;
      delete candidate.item;
      delete candidate.exactNameMatch;
    });

    let resultLimit = typeof limit === "number" && limit >= 0 ? Math.floor(limit) : results.length;
    return results.slice(0, resultLimit);
  }

  function buildItem(subject, originalIndex, language) {
    let safeSubject = subject || {};
    let name = language === "en" ? safeSubject.nameEN : safeSubject.name;
    let content = language === "en" ? safeSubject.contentEN : safeSubject.content;
    let category = language === "en" ? safeSubject.categoryEN : safeSubject.category;
    let preparedName = prepareText(name, language);
    let preparedCategory = prepareText(category, language);

    return {
      subject: safeSubject,
      originalIndex,
      name: preparedName,
      nameDocument: createDocument(preparedName.tokens),
      contentParts: splitContent(content)
        .map(part => ({ raw: part, prepared: prepareText(part, language) }))
        .filter(part => part.prepared.tokens.length > 0 && !isGenericContent(part.prepared.phrase))
        .map(part => ({
          raw: part.raw,
          prepared: part.prepared,
          document: createDocument(part.prepared.tokens)
        })),
      aliases: splitValues(safeSubject.tags).map(alias => prepareText(alias, language)).filter(alias => alias.phrase),
      packageTags: parsePackageTags(safeSubject.packageTags),
      category: preparedCategory,
      isMostUsed: normalizePhrase(safeSubject.category3) === "najcastejsie"
    };
  }

  function normalizePhrase(value) {
    return removeDiacritics(normalizePhrasePreservingDiacritics(value))
      .replace(/[^a-z0-9]+/g, " ")
      .trim()
      .replace(/\s+/g, " ");
  }

  function normalizePhrasePreservingDiacritics(value) {
    if (value === null || typeof value === "undefined") {
      return "";
    }

    return String(value)
      .replace(/<[^>]*>/g, " ")
      .replace(/&[a-z0-9#]+;/gi, " ")
      .toLowerCase()
      .replace(/[^a-z0-9áäčďéíľĺňóôŕšťúýž]+/g, " ")
      .trim()
      .replace(/\s+/g, " ");
  }

  function prepareText(value, language) {
    let phrasePreservingDiacritics = normalizePhrasePreservingDiacritics(value);
    let phrase = normalizePhrase(value);
    let rawTokens = phrase ? phrase.split(" ") : [];
    let tokens = language === "sk"
      ? phrasePreservingDiacritics.split(" ").map(token => normalizePhrase(stemSlovakToken(token))).filter(Boolean)
      : rawTokens;

    return {
      phrase,
      compact: phrase.replace(/\s+/g, ""),
      rawTokens,
      tokens
    };
  }

  function stemSlovakToken(token) {
    if (token.length <= 3) {
      return token;
    }

    for (let i = 0; i < SlovakSuffixes.length; i++) {
      let suffix = SlovakSuffixes[i];
      if (token.endsWith(suffix)) {
        let stem = token.substring(0, token.length - suffix.length);
        if (suffix.startsWith("i") && /[czg]$/.test(stem)) {
          return stem + "i";
        }
        if (suffix.startsWith("e") || suffix.startsWith("i")) {
          return softenDtnl(stem);
        }
        if (/^[^aáäeéiíoóôuúyý]*[rŕlĺ]$/.test(stem)) {
          return token;
        }
        return stem;
      }
    }

    for (let i = 0; i < SlovakSpecialEndings.length; i++) {
      let specialEnding = SlovakSpecialEndings[i];
      if (token.endsWith(specialEnding.ending)) {
        return token.substring(0, token.length - specialEnding.ending.length) + specialEnding.replacement;
      }
    }

    return token;
  }

  function softenDtnl(value) {
    let replacements = { d: "ď", t: "ť", n: "ň", l: "ľ" };
    let lastCharacter = value.charAt(value.length - 1);
    if (!replacements[lastCharacter]) {
      return value;
    }
    return value.substring(0, value.length - 1) + replacements[lastCharacter];
  }

  function splitContent(value) {
    if (!value) {
      return [];
    }

    return String(value)
      .replace(/<br\s*\/?>/gi, "\n")
      .replace(/<\/(p|div|li)>/gi, "\n")
      .replace(/<li[^>]*>/gi, "")
      .split(/\n+/)
      .map(part => part.replace(/<[^>]*>/g, " ").replace(/&nbsp;/gi, " ").trim())
      .filter(Boolean);
  }

  function isGenericContent(phrase) {
    return GenericContentPrefixes.some(prefix => phrase.startsWith(prefix));
  }

  function splitValues(value) {
    if (!value) {
      return [];
    }
    return String(value).split(/[;,]/).map(part => part.trim()).filter(Boolean);
  }

  function parsePackageTags(value) {
    return splitValues(value).map((tag, tagIndex) => {
      let match = normalizePhrase(tag).match(/^([a-z][a-z0-9]*)\s*(\d+)$/);
      if (!match) {
        return null;
      }
      return {
        category: match[1],
        order: parseInt(match[2], 10),
        tagIndex
      };
    }).filter(Boolean);
  }

  function createDocument(tokens) {
    let termFrequency = {};
    tokens.forEach(token => {
      termFrequency[token] = (termFrequency[token] || 0) + 1;
    });
    return { tokens, termFrequency, length: tokens.length };
  }

  function createCorpus(documents) {
    let documentFrequency = {};
    let totalLength = 0;

    documents.forEach(document => {
      totalLength += document.length;
      let seen = {};
      document.tokens.forEach(token => {
        if (!seen[token]) {
          seen[token] = true;
          documentFrequency[token] = (documentFrequency[token] || 0) + 1;
        }
      });
    });

    return {
      size: documents.length,
      averageLength: documents.length ? totalLength / documents.length : 0,
      documentFrequency
    };
  }

  function uniqueTokens(tokens) {
    let seen = {};
    return tokens.filter(token => {
      if (seen[token]) {
        return false;
      }
      seen[token] = true;
      return true;
    });
  }

  function bm25Score(document, queryTokens, corpus) {
    if (!corpus.size || !document.length) {
      return 0;
    }

    return uniqueTokens(queryTokens).reduce((score, token) => {
      let termFrequency = document.termFrequency[token] || 0;
      let documentFrequency = corpus.documentFrequency[token] || 0;
      if (!termFrequency || !documentFrequency) {
        return score;
      }

      let inverseDocumentFrequency = Math.log(1 + (corpus.size - documentFrequency + 0.5) / (documentFrequency + 0.5));
      let lengthNormalization = 1 - Bm25B + Bm25B * document.length / (corpus.averageLength || 1);
      return score + inverseDocumentFrequency * termFrequency * (Bm25K1 + 1) /
        (termFrequency + Bm25K1 * lengthNormalization);
    }, 0);
  }

  function rankNames(queryTokens) {
    return index.items
      .map(item => ({ item, score: bm25Score(item.nameDocument, queryTokens, index.nameCorpus) }))
      .filter(result => result.score > 0)
      .sort(compareScoredResults);
  }

  function rankContent(queryTokens) {
    return index.items.map(item => {
      let bestPart = null;
      let bestScore = 0;

      item.contentParts.forEach(part => {
        let score = bm25Score(part.document, queryTokens, index.contentCorpus);
        if (score > bestScore) {
          bestScore = score;
          bestPart = part;
        }
      });

      return {
        item,
        score: bestScore,
        matchedContent: bestPart ? bestPart.raw : null
      };
    }).filter(result => result.score > 0).sort(compareScoredResults);
  }

  function rankContentPhrases(query) {
    return index.items.map(item => {
      let matchedPart = item.contentParts.find(part => part.prepared.phrase.includes(query.phrase));
      return matchedPart ? { item, matchedContent: matchedPart.raw } : null;
    }).filter(Boolean);
  }

  function compareScoredResults(left, right) {
    if (right.score !== left.score) {
      return right.score - left.score;
    }
    return left.item.originalIndex - right.item.originalIndex;
  }

  function rankAliases(query) {
    return index.items.map(item => {
      let bestMatch = null;

      item.aliases.forEach(alias => {
        let match = {
          exact: alias.phrase === query.phrase || alias.compact === query.compact ? 1 : 0,
          stemExact: alias.tokens.join(" ") === query.tokens.join(" ") ? 1 : 0,
          matchedTokens: countExactTokenMatches(query.tokens, alias.tokens),
          aliasLength: alias.tokens.length
        };
        if ((match.exact || match.stemExact || match.matchedTokens > 0) &&
          (!bestMatch || compareAliasMatches(match, bestMatch) < 0)) {
          bestMatch = match;
        }
      });

      return bestMatch ? { item, match: bestMatch } : null;
    }).filter(Boolean).sort((left, right) => {
      let compared = compareAliasMatches(left.match, right.match);
      return compared || left.item.originalIndex - right.item.originalIndex;
    });
  }

  function compareAliasMatches(left, right) {
    if (right.exact !== left.exact) {
      return right.exact - left.exact;
    }
    if (right.stemExact !== left.stemExact) {
      return right.stemExact - left.stemExact;
    }
    if (right.matchedTokens !== left.matchedTokens) {
      return right.matchedTokens - left.matchedTokens;
    }
    return left.aliasLength - right.aliasLength;
  }

  function countExactTokenMatches(queryTokens, targetTokens) {
    let targetSet = {};
    targetTokens.forEach(token => { targetSet[token] = true; });
    return uniqueTokens(queryTokens).filter(token => targetSet[token]).length;
  }

  function buildPackageProfiles(items, categoryDefinitions, language) {
    let profiles = {};

    Object.keys(categoryDefinitions).forEach(category => {
      profiles[category] = createCategoryProfile(category, categoryDefinitions[category], language);
    });

    items.forEach(item => {
      item.packageTags.forEach(packageTag => {
        let profile = profiles[packageTag.category];
        if (!profile) {
          profile = createCategoryProfile(packageTag.category, packageTag.category, language);
          profiles[packageTag.category] = profile;
        }
        profile.hasPackageSubjects = true;
      });

      let representedProfiles = item.packageTags
        .map(packageTag => profiles[packageTag.category])
        .filter((profile, profileIndex, itemProfiles) => itemProfiles.indexOf(profile) === profileIndex)
        .filter(profile => item.aliases.some(alias => profile.identityAliases.some(identityAlias => {
          return alias.phrase === identityAlias.phrase || alias.compact === identityAlias.compact;
        })));

      if (representedProfiles.length === 1) {
        item.aliases.forEach(alias => addProfileAlias(representedProfiles[0], alias));
      }
    });

    return profiles;
  }

  function buildCategory2Profile(categoryDefinitions, language) {
    let label = categoryDefinitions.eshop || "eshop";
    return createCategoryProfile("eshop", label, language);
  }

  function createCategoryProfile(key, label, language) {
    let keyAlias = prepareText(key, language);
    let labelAlias = prepareText(label, language);
    let profile = {
      key,
      aliases: [],
      identityAliases: [keyAlias, labelAlias],
      tokenPairs: [],
      seenAliases: {},
      seenTokenPairs: {},
      hasPackageSubjects: false
    };
    addProfileAlias(profile, keyAlias);
    addProfileAlias(profile, labelAlias);
    return profile;
  }

  function addProfileAlias(profile, alias) {
    if (!alias.phrase || profile.seenAliases[alias.phrase]) {
      return;
    }
    profile.seenAliases[alias.phrase] = true;
    profile.aliases.push(alias);

    alias.rawTokens.forEach((rawToken, tokenIndex) => {
      let stem = alias.tokens[tokenIndex] || rawToken;
      let pairKey = rawToken + ":" + stem;
      if (!profile.seenTokenPairs[pairKey]) {
        profile.seenTokenPairs[pairKey] = true;
        profile.tokenPairs.push({ raw: rawToken, stem });
      }
    });
  }

  function rankPackageTags(query) {
    let category = resolvePackageCategory(query);
    if (!category) {
      return { results: [], matchedBy: null };
    }

    let results = index.items.map(item => {
      let matchingTags = item.packageTags.filter(packageTag => packageTag.category === category);
      if (!matchingTags.length) {
        return null;
      }
      matchingTags.sort((left, right) => left.order - right.order || left.tagIndex - right.tagIndex);
      return { item, packageOrder: matchingTags[0].order };
    }).filter(Boolean).sort((left, right) => {
      return left.packageOrder - right.packageOrder || left.item.originalIndex - right.item.originalIndex;
    });

    return { results, matchedBy: "package:" + category };
  }

  function resolvePackageCategory(query) {
    let matches = Object.keys(index.packageProfiles)
      .map(key => index.packageProfiles[key])
      .filter(profile => profile.hasPackageSubjects)
      .map(profile => evaluateCategoryProfile(profile, query))
      .filter(match => match.exact || match.matchedTokens > 0)
      .sort(compareCategoryMatches);

    if (!matches.length || !isSufficientCategoryMatch(matches[0], query)) {
      return null;
    }
    if (matches.length > 1 && compareCategoryMatchStrength(matches[0], matches[1]) === 0) {
      return null;
    }
    return matches[0].profile.key;
  }

  function evaluateCategoryProfile(profile, query) {
    let exact = profile.aliases.some(alias => alias.phrase === query.phrase || alias.compact === query.compact);
    let queryTokenPairs = significantTokenPairs(query);
    let matchedTokens = queryTokenPairs.filter(queryToken => {
      return profile.tokenPairs.some(profileToken => relatedTokens(queryToken, profileToken));
    }).length;

    return {
      profile,
      exact: exact ? 1 : 0,
      matchedTokens,
      coverage: queryTokenPairs.length ? matchedTokens / queryTokenPairs.length : 0
    };
  }

  function significantTokenPairs(preparedText) {
    return preparedText.rawTokens.map((rawToken, tokenIndex) => ({
      raw: rawToken,
      stem: preparedText.tokens[tokenIndex] || rawToken
    })).filter(token => token.raw.length > 2);
  }

  function relatedTokens(left, right) {
    if (left.raw === right.raw || left.stem === right.stem) {
      return true;
    }
    let leftValue = left.stem || left.raw;
    let rightValue = right.stem || right.raw;
    let shortestLength = Math.min(leftValue.length, rightValue.length);
    return shortestLength >= 4 && (leftValue.startsWith(rightValue) || rightValue.startsWith(leftValue));
  }

  function compareCategoryMatches(left, right) {
    let strength = compareCategoryMatchStrength(left, right);
    if (strength) {
      return strength;
    }
    return left.profile.key.localeCompare(right.profile.key);
  }

  function compareCategoryMatchStrength(left, right) {
    if (right.exact !== left.exact) {
      return right.exact - left.exact;
    }
    if (right.matchedTokens !== left.matchedTokens) {
      return right.matchedTokens - left.matchedTokens;
    }
    return right.coverage - left.coverage;
  }

  function isSufficientCategoryMatch(match, query) {
    if (match.exact) {
      return true;
    }
    let queryTokenCount = significantTokenPairs(query).length;
    return match.matchedTokens > 0 && queryTokenCount > 0 && match.coverage >= 0.5;
  }

  function rankCategory2(query) {
    let match = evaluateCategoryProfile(index.category2Profile, query);
    if (!isSufficientCategoryMatch(match, query)) {
      return [];
    }
    return index.items
      .filter(item => normalizePhrase(item.subject.category2) === "eshop")
      .map(item => ({ item }));
  }

  function rankCategories(query) {
    return index.items.map(item => {
      if (!item.category.phrase || IgnoredCategories[item.category.phrase]) {
        return null;
      }
      let exact = item.category.phrase === query.phrase ? 1 : 0;
      let phraseMatch = item.category.phrase.includes(query.phrase) ? 1 : 0;
      let matchedTokens = countExactTokenMatches(query.tokens, item.category.tokens);
      let allTokensMatched = query.tokens.length > 0 && matchedTokens === uniqueTokens(query.tokens).length;
      if (!exact && !phraseMatch && !allTokensMatched) {
        return null;
      }
      return { item, exact, phraseMatch, matchedTokens };
    }).filter(Boolean).sort((left, right) => {
      if (right.exact !== left.exact) {
        return right.exact - left.exact;
      }
      if (right.phraseMatch !== left.phraseMatch) {
        return right.phraseMatch - left.phraseMatch;
      }
      if (right.matchedTokens !== left.matchedTokens) {
        return right.matchedTokens - left.matchedTokens;
      }
      return left.item.originalIndex - right.item.originalIndex;
    });
  }

  function addExactNameMatches(candidates, query) {
    index.items.forEach(item => {
      let exactNameMatch = null;
      if (item.name.phrase === query.phrase) {
        exactNameMatch = 0;
      } else if (item.name.phrase.startsWith(query.phrase)) {
        exactNameMatch = 1;
      } else if (item.name.phrase.includes(query.phrase)) {
        exactNameMatch = 2;
      }

      if (exactNameMatch !== null) {
        let candidate = getCandidate(candidates, item);
        candidate.exactNameMatch = exactNameMatch;
        addMatchedBy(candidate, exactNameMatch === 0 ? "exact-name" : exactNameMatch === 1 ? "name-prefix" : "name-phrase");
      }
    });
  }

  function addRanking(candidates, ranking, rankName, matchedBy) {
    ranking.forEach((result, resultIndex) => {
      let candidate = getCandidate(candidates, result.item);
      candidate.ranks[rankName] = resultIndex + 1;
      candidate.rrfScore += 1 / (RrfK + resultIndex + 1);
      addMatchedBy(candidate, matchedBy);
      if (result.matchedContent) {
        candidate.matchedContent = result.matchedContent;
      }
    });
  }

  function getCandidate(candidates, item) {
    let key = String(item.originalIndex);
    if (!candidates[key]) {
      candidates[key] = {
        item,
        subject: item.subject,
        finalRank: null,
        rrfScore: 0,
        matchedBy: [],
        matchedContent: null,
        ranks: {
          name: null,
          content: null,
          contentPhrase: null,
          packageTag: null,
          alias: null,
          category2: null,
          category: null
        },
        exactNameMatch: 3
      };
    }
    return candidates[key];
  }

  function addMatchedBy(candidate, matchedBy) {
    if (matchedBy && candidate.matchedBy.indexOf(matchedBy) === -1) {
      candidate.matchedBy.push(matchedBy);
    }
  }

  function compareCandidates(left, right) {
    if (left.exactNameMatch !== right.exactNameMatch) {
      return left.exactNameMatch - right.exactNameMatch;
    }
    if (right.rrfScore !== left.rrfScore) {
      return right.rrfScore - left.rrfScore;
    }

    let nameRank = compareNullableRanks(left.ranks.name, right.ranks.name);
    if (nameRank) {
      return nameRank;
    }
    let packageRank = compareNullableRanks(left.ranks.packageTag, right.ranks.packageTag);
    if (packageRank) {
      return packageRank;
    }
    let contentRank = compareNullableRanks(left.ranks.content, right.ranks.content);
    if (contentRank) {
      return contentRank;
    }
    if (left.item.isMostUsed !== right.item.isMostUsed) {
      return left.item.isMostUsed ? -1 : 1;
    }
    return left.item.originalIndex - right.item.originalIndex;
  }

  function compareNullableRanks(left, right) {
    if (left === right) {
      return 0;
    }
    if (left === null) {
      return 1;
    }
    if (right === null) {
      return -1;
    }
    return left - right;
  }
}

angular.module("firmaren")
  .factory("BusinessSubjectSearchEngine", BusinessSubjectSearchEngineFactory);
}());
